export enum PaymentMethods {
  CreditCard = 'credit_card',
  BankTransfer = 'bank_transfer',
  ApplePay = 'apple_pay',
  Paypal = 'paypal',
  Ideal = 'ideal',
}

export type PaymentMethod = (typeof PaymentMethods)[keyof typeof PaymentMethods];
